import { useMutation, useQuery } from '@tanstack/react-query'

import { Car, StorePersistKeys, Timestamp } from 'src/types'

import { useAppDispatch } from 'src/hooks/useAppDispatch'
import {
  getListOfUsersCars,
  deleteUserCar,
  addUserCar,
  setActiveCar,
  updateDataUserCar,
} from 'src/api/UserCars'

import { userSlice } from 'src/store/reducers/UserReducer/UserSlice'

export const useManageUserCars = () => {
  const dispatch = useAppDispatch()
  const { setActiveCar: addToStoreActiveCar } = userSlice.actions

  const { data: userCars, isLoading: isLoadingGetCars } = useQuery({
    queryKey: [StorePersistKeys.USER_CARS],
    queryFn: getListOfUsersCars,
    onSuccess: (data: Car<Timestamp>[]): void => {
      const activeCar = data.find(car => car.isActive)

      if (!activeCar) return

      dispatch(addToStoreActiveCar(activeCar.carNumber))
    },
  })

  const { mutate: addCar, isLoading: isLoadingAddCar } = useMutation({
    mutationKey: [StorePersistKeys.USER_CARS],
    mutationFn: addUserCar,
  })

  const { mutate: updateCar, isLoading: isLoadingUpdateCar } = useMutation({
    mutationKey: [StorePersistKeys.USER_CARS],
    mutationFn: updateDataUserCar,
  })

  const { mutate: deleteCar, isLoading: isLoadingDeleteCar } = useMutation({
    mutationKey: [StorePersistKeys.USER_CARS],
    mutationFn: deleteUserCar,
  })

  const { mutate: setActiveCarMutate, isLoading: isLoadingSetActiveCar } =
    useMutation({
      mutationKey: [StorePersistKeys.USER_CARS],
      mutationFn: setActiveCar,
    })

  return {
    userCars,
    addCar,
    updateCar,
    deleteCar,
    setActiveCar: setActiveCarMutate,
    isLoadingGetCars,
    isLoadingAddCar,
    isLoadingUpdateCar,
    isLoadingDeleteCar,
    isLoadingSetActiveCar,
    isLoadingGeneral:
      isLoadingGetCars ||
      isLoadingAddCar ||
      isLoadingUpdateCar ||
      isLoadingDeleteCar ||
      isLoadingSetActiveCar,
  }
}
